import { useState, useEffect, useRef, Fragment, memo, useContext } from "react";
import style from "./../index.module.scss";
import styleUi from "./Invatation.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import * as YStyled from "../../Styleds";
import AppConfig from './../../AppConfig';
import { addTextToImage } from "../../comm/comm";
import SwifeItem from "../../comm/global/components/SwifeItem";
import { GameContext } from "../../GameContext";
import apiManager from '../../ApiManager';
import Hammer from "hammerjs";

const Invatation = ({ setModalType, arg, addModalType }) => {
    const { userData, preProcessEvent } = useContext(GameContext);
    const [inProp, setInProp] = useState(false);
    const [selectIndex, set_selectIndex] = useState(0);
    const [invites, set_invites] = useState([]);
    const divRef = useRef(null);
    const [isSwiping, set_isSwiping] = useState(false);
    useEffect(() => {
        setInProp(true);
        document.title = "邀請函";
        fetchAllEvents(arg.invitations);
    }, [])
    useEffect(() => {
        console.log("divRef.current", divRef.current)
        if (divRef.current) {
            const hammer = new Hammer(divRef.current);

            // 啟用 swipe 偵測
            hammer.get("swipe").set({ direction: Hammer.DIRECTION_HORIZONTAL });

            hammer.on("swiperight", (event) => {
                set_isSwiping(true);
                setTimeout(() => {
                    set_isSwiping(false);
                }, 300);
                set_selectIndex(prev => {
                    if (prev > 0)
                        return prev - 1;
                    else
                        return prev;
                });
            });

            hammer.on("swipeleft", (event) => {
                set_isSwiping(true);
                setTimeout(() => {
                    set_isSwiping(false);
                }, 300);
                set_selectIndex(prev => {
                    if (prev < invites.length - 1)
                        return prev + 1;
                    else
                        return prev;
                });
            });

            return () => {
                hammer.off("swipeleft");
                hammer.off("swiperight");
                hammer.destroy();
            };
        }
    }, [invites])
    const fetchAllEvents = async (invitations) => {
        try {
            // 對每個 invitation 取得對應的 event
            const allEventsPromises = invitations.map(item =>
                apiManager.fetchGet(`event/${item.event_participants_event}`, {}, 0)
            );

            // 等待所有事件請求完成
            const allEventsResults = await Promise.all(allEventsPromises);
            console.log("allEventsResults", allEventsResults);

            // 處理所有事件
            const processEvents = async () => {
                const __events = await Promise.all(invitations.map(async (item, index) => {
                    const event = allEventsResults[index]; // 取出對應的 event
                    const eventVo = await preProcessEvent(event);
                    return { eventVo, invitation: item }; // 返回 eventVo 與 invitation
                }));

                __events.forEach(({ eventVo, invitation }) => {
                    const findObj = AppConfig.modeEnum.find(v => v.id === eventVo.events_type);
                    const selTempInd = getStyleIndex(eventVo);
                    const posDetail = AppConfig.InvitePosDetail(selTempInd - 1, eventVo, findObj);

                    addTextToImage(`./assets/ui/invite${selTempInd}.png`, posDetail).then(img1 => {
                        addTextToImage(`./assets/ui/invite${selTempInd}b.png`, [{
                            type: "text",
                            text: `${eventVo.events_invitation_message}`,
                            fontSize: 36,
                            x: 450,
                            y: 406,
                            maxWidth: 580,
                            color: "#B34438",
                            fontWeight: 500
                        }]).then(img2 => {
                            set_invites(prev => [...prev, { eventVo, img1, img2, invitation, selTempInd }]); // 把 invitation 帶進來
                        });
                    });
                });
            };

            processEvents();
        } catch (error) {
            console.error("Error fetching events:", error);
        }
    };

    function getStyleIndex(eventVo) {
        const ind = eventVo.events_invitation_template.split("_")[1];
        if (!ind) {
            return 0;
        }
        else
            return parseInt(ind);
    }
    return (
        <div className={style.modal}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.SwipePageEnterActive,
                enterDone: style.SwipePageEnterDone,
                exitActive: style.SwipePageExit,
                exitDone: style.SwipePageExitActive
            }}
                onExited={async () => {
                    await new Promise(resolve => requestAnimationFrame(resolve));
                    setModalType(prev => prev.filter(v => v.cls !== "Invatation"))
                }}
            >
                <div className={`${style.SwipePage} ${style.Page}`} >
                    <div className={styleUi.app}>
                        <div className={styleUi.headerBar}>
                            <img src="./assets/ui/back.png" onClick={e => { setInProp(false) }} />
                        </div>
                        <div className={styleUi.view}>
                            {arg.invitations.length === 0 ?
                                <YStyled.Col align="center" style={{ marginTop: "50%" }}>
                                    <img src="./assets/ui/noResult.png" />
                                    <YStyled.Span>無任何邀請函</YStyled.Span>
                                </YStyled.Col>
                                :
                                <>
                                    <div className={styleUi.cards} ref={divRef} style={{ transform: `translateX(${15 - selectIndex * 70}%)` }}>
                                        {invites.map((inviteVo, k) => {
                                            console.log("inviteVo", inviteVo.selTempInd)
                                            return <div key={k} className={`${styleUi.card} ${selectIndex === k ? styleUi.current : ""}`}>
                                                <SwifeItem enabled={!isSwiping} page1={
                                                    <YStyled.InviteBg width="100%" img={inviteVo.img1}>
                                                    </YStyled.InviteBg>
                                                }
                                                    page2={
                                                        <div className={styleUi.back}>
                                                            <YStyled.InviteBg width="100%" img={`./assets/ui/invite${inviteVo.selTempInd}b.png`}>
                                                                <YStyled.StyledTextarea readOnly  style={{ userSelect: 'none', pointerEvents: 'none' }}  value={inviteVo.eventVo.events_invitation_message}
                                                                    marginTop={AppConfig.msgPos[inviteVo.selTempInd].marginTop}
                                                                    lineHeight={AppConfig.msgPos[inviteVo.selTempInd].lineHeight}
                                                                    height={AppConfig.msgPos[inviteVo.selTempInd].height}
                                                                    width={AppConfig.msgPos[inviteVo.selTempInd].width}
                                                                ></YStyled.StyledTextarea>
                                                            </YStyled.InviteBg>
                                                            <YStyled.BTN3 onClick={e => {
                                                                e.stopPropagation();
                                                                console.log("invi", inviteVo)
                                                                addModalType({
                                                                    cls: "EventDetail", arg: {

                                                                        cb: () => {
                                                                        },
                                                                        vo: inviteVo.eventVo
                                                                    }
                                                                })
                                                            }}>
                                                                <YStyled.Span size={17} fontWeight={700} color="#553711">{`查看`}</YStyled.Span>
                                                            </YStyled.BTN3>
                                                        </div>
                                                    }
                                                ></SwifeItem>
                                            </div>
                                        })}
                                    </div>
                                    <div className={styleUi.swift}>
                                        <div className={`${styleUi.btn} ${styleUi.leftBtn} ${selectIndex === 0 ? styleUi.disable : ""}`} onClick={e => {
                                            if (selectIndex > 0)
                                                set_selectIndex(prev => prev - 1);
                                        }}>
                                            <img src="./assets/ui/RedArrowRight.png" />
                                        </div>
                                        <div className={styleUi.dots} style={{ width: `${invites.length >= 3 ? "3rem" : "auto"}` }}>
                                            {invites.map((v, k) => {
                                                let adjustedIndex = selectIndex;

                                                if (selectIndex === 0) {
                                                    adjustedIndex = 1; // 讓 0 的時候顯示跟 1 一樣
                                                } else if (selectIndex === invites.length - 1) {
                                                    adjustedIndex = invites.length - 2; // 讓最後一個顯示跟倒數第二個一樣
                                                }

                                                return (
                                                    <div key={k} className={styleUi.dot} style={{ transform: `translateX(${invites.length >= 3 ? -adjustedIndex + 1 : 0}rem)` }}>
                                                        <div className={`${selectIndex === k ? styleUi.selected : ""}`}></div>
                                                    </div>
                                                );
                                            })}

                                        </div>

                                        <div className={`${styleUi.btn} ${styleUi.rightBtn} ${selectIndex >= invites.length - 1 ? styleUi.disable : ""}`} onClick={e => {
                                            if (selectIndex < invites.length - 1)
                                                set_selectIndex(prev => prev + 1);
                                        }}>
                                            <img src="./assets/ui/RedArrowRight.png" />
                                        </div>
                                    </div>
                                </>
                            }

                        </div>
                    </div>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(Invatation);